import { MESSAGE_TYPE } from 'shared/constants/messages';

const FALLBACK_TITLE = 'Nuevo mensaje';
const FALLBACK_BODY = 'Nuevo mensaje recibido';

const getContactName = message => {
  const sender =
    message?.conversation?.meta?.sender ||
    message?.sender ||
    message?.conversation?.contact;

  return (
    sender?.name ||
    sender?.available_name ||
    (message?.conversation?.display_id &&
      `Conversacion #${message.conversation.display_id}`) ||
    FALLBACK_TITLE
  );
};

const getMessageBody = message => {
  if (message?.content) {
    return message.content;
  }

  if (message?.processed_message_content) {
    return message.processed_message_content;
  }

  if (message?.attachments?.length) {
    return 'Nuevo archivo adjunto';
  }

  return FALLBACK_BODY;
};

const getConversationUrl = message => {
  const accountId = message?.account_id || message?.conversation?.account_id;
  const conversationId = message?.conversation_id || message?.conversation?.id;

  if (!accountId || !conversationId) {
    return '';
  }

  return `/app/accounts/${accountId}/conversations/${conversationId}`;
};

export const notifyOnIncomingMessage = message => {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return;
  }

  if (Notification.permission !== 'granted') {
    return;
  }

  if (message?.message_type !== MESSAGE_TYPE.INCOMING) {
    return;
  }

  if (message?.private) {
    return;
  }

  const notification = new Notification(getContactName(message), {
    body: getMessageBody(message),
    icon: window.chatwootConfig?.logo || '/brand-assets/logo_thumbnail.svg',
    tag: `chatwoot-conversation-${message?.conversation_id || message?.conversation?.id || message?.id}`,
  });

  notification.onclick = () => {
    window.focus();
    const conversationUrl = getConversationUrl(message);

    if (conversationUrl) {
      window.location.href = conversationUrl;
    }

    notification.close();
  };
};
